var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16082_27069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7877 0.5C16.1212 0.5 16.441 0.633332 16.6757 0.870327L19.6381 3.86097C19.8699 4.09504 20 4.41118 20 4.74064V18C20 19.3807 18.8807 20.5 17.5 20.5H2.5C1.11929 20.5 0 19.3807 0 18V3C0 1.61929 1.11929 0.5 2.5 0.5H15.7877ZM3.75 3H2.5V18H3.75V11.75C3.75 11.0596 4.30964 10.5 5 10.5H15C15.6904 10.5 16.25 11.0596 16.25 11.75V18H17.5V5.25493L15.2664 3H11.25V6.75C11.25 7.44036 10.6904 8 10 8H5C4.30964 8 3.75 7.44036 3.75 6.75V3ZM13.75 13H6.25V18H13.75V13ZM8.75 3H6.25V5.5H8.75V3Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16082_27069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.bc3fb35d518f023929589fbbfe7b43fc.svg";
export { ForwardRef as ReactComponent };